import Footer from '@components/Footer/Footer';
import Header from '@components/Header/Header';
import NotFoundPage from '@routes/NotFound/NotFound';
import { Navigate, Outlet, useLocation } from 'react-router';

import './Legal.css';

const Legal = () => {
	const location = useLocation();
	if (location.pathname === '/legal') {
		return <Navigate to="/legal/" replace />;
	}
	const validPaths = ['/legal/terms-of-use', '/legal/privacy-policy', '/legal/cookie-preferences'];

	if (location.pathname !== '/legal' && !validPaths.includes(location.pathname)) {
		return <NotFoundPage />;
	}
	return (
		<div id="legal" className="page">
			<Header />
			<Outlet />
			<Footer />
		</div>
	);
};

export default Legal;
